import { createFileRoute } from "@tanstack/react-router";
import { CategoryPage } from "@/components/CategoryPage";
import { getAllPosts } from "@/lib/posts.functions";
import { listApprovedThemes } from "@/lib/themes-public.functions";
import { useLocalizedPosts } from "@/lib/wp.hooks";
import { useT } from "@/lib/i18n";
import { hreflangLinks } from "@/lib/seo";
import { pageTitle } from "@/lib/brand";

export const Route = createFileRoute("/surdurulebilirlik")({
  head: () => ({
    meta: [
      { title: pageTitle("Sürdürülebilirlik Eleştirisi", "tr") },
      { name: "description", content: "Yeşil aklama, ESG ve net sıfır söyleminin sınırları üzerine eleştirel denemeler: taahhüt borcu, ayrışma tezi ve raporlamanın kanıt sorunu." },
      { property: "og:title", content: "Sürdürülebilirlik Eleştirisi — Akıllı Sürdürülebilirlik" },
      { property: "og:description", content: "Sürdürülebilirlik söyleminin sınırları üzerine eleştirel denemeler." },
      { property: "og:url", content: "https://akillisurdurulebilirlik.com/surdurulebilirlik" },
      { property: "og:locale", content: "tr_TR" },
      { property: "og:locale:alternate", content: "en_US" },
    ],
    links: [
      { rel: "canonical", href: "https://akillisurdurulebilirlik.com/surdurulebilirlik" },
      ...hreflangLinks("/surdurulebilirlik", "/sustainability-critique"),
    ],
  }),
  loader: async () => {
    const [posts, themes] = await Promise.all([getAllPosts(), listApprovedThemes()]);
    return { posts, themes };
  },
  component: Page,
});

function Page() {
  const { t } = useT();
  const data = Route.useLoaderData();
  const { articles: posts } = useLocalizedPosts(data.posts);
  return (
    <CategoryPage
      themes={data.themes}
      category={t("cat.sustain.title")}
      tagline={t("cat.sustain.tagline")}
      essays={posts.filter((p) => String(p.category) === "Sustainability Critique" || String(p.category) === "Sürdürülebilirlik Eleştirisi" || String(p.category) === "Sürdürülebilirlik")}
    />
  );
}
